<template>
  <div class="box">
    <!-- 标题和搜索盒子 -->
    <div class="headlogo">
      <!-- 左侧盒子 -->
      <div class="head-left">
        <!-- logo -->
          <div class="msoimg">
            <img src="../../assets/imgs/clurlogo.png" alt="">
          </div>
          <!-- logo标题 -->
          <div class="mso-title">
            <div class="text1">
              江苏海宏智能科技有限公司
            </div>
            <div class="text2">
              -JIANGSU OCEAN&MACRO INTELLIGENT TECHNOLOGY Co., Ltd.-
            </div>
          </div>
      </div>
      <!-- 右侧盒子 -->
      <div class="head-rgiht">
        <!-- 微信公众号 -->
        <div class="weChat-official-account">
          <img src="../../assets/imgs/微信.png" alt="">
          <div class="a-left-box">
            <el-button type="text" class="but-left">微信公众号</el-button>
          </div>
          <el-button type="text" class="but-right">收藏本站</el-button>
          <!-- 二维码 -->
          <div class="QR-code">
            <img src="../../assets/imgs/公众号 拷贝.png" alt="">
          </div>
        </div>
        <!-- 右侧搜索输入框和按钮 -->
        <div class="head-inp">
          <el-input type="text" placeholder="输入关键词搜索" v-model="search"></el-input>
          <el-button class="head-but" @click="searchbtn">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 导航栏盒子 -->
    <el-breadcrumb class="Navigation">
        <el-breadcrumb-item class="a-link" :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: './AboutUs' }"><a>关于我们</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/ProductCenter' }"><a>产品中心</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/CaseSharing' }"><a>案例分享</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/TalentRecruitment' }"><a>人才招聘</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Businesscooperation' }"><a>商务合作</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Notice' }"><a>公告</a></el-breadcrumb-item>
        <!-- <el-breadcrumb-item class="a-link" :to="{ path: '/News' }"><a>企业新闻</a></el-breadcrumb-item> -->
        <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 顶部图片盒子 -->
    <div class="top-box">
      <p class="top-p1">案例分享</p>
      <p class="top-p2">SUCCESS CASE</p>
    </div>
    <!-- 您的位置 -->
    <div class="location-top">
      <p>您的位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/CaseSharing' }">案例分享</el-breadcrumb-item>
        <el-breadcrumb-item>智能仓储</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 智能移动机器人小车系列 -->
    <div class="title">
      智能移动机器人小车系列
      <p class="title-box"></p>
    </div>
    <!-- 下方文字介绍 -->
    <div class="text">
      江苏海宏科技设计的AMR智能移动机器人全部使用麦克纳姆轮技术，四轮独立驱动，采用自主独立研发的MSO运动控制器，能实现车体的直行，侧移，斜行，自转，组合漂移等全方位移动。通过纯算法，室外RTK设备，视觉探测和激光雷达测距、二维码定位等来感知周围环境和障碍物，可在二维平面无死角任意进行高精度移动。
    </div>
    <!-- 经典案例 -->
    <div class="title1">
      经典案例
      <p class="title1-box"></p>
    </div>
    <!-- 底部图片内容 -->
    <div class="bottom-img">
      <!-- 内容里面小盒子 -->
      <div class="bottom-img1" v-for="item in urls" :key="item.id">
        <img :src="item.url" alt="">
        <p>{{item.text}}</p>
      </div>
      <div class="bottom-img2">
        <img src="../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/图片1.png" alt="">
        <p>智能移动机器人</p>
      </div>
    </div>
    <!-- 底部盒子 -->
    <div class="bottom-box">
    <!-- 左侧大楼图片盒子 -->
      <div class="bottom-box-left">
            <img src="../../assets/imgs/建筑.png" alt="">
      </div>
      <!-- 底部信息 -->
      <div class="bottom-box-right">
        <p class="bottom-box-right-text">
          关于我们 | 网站地图 | 网站声明 <br />
          联系电话：19901541926 (武经理 微信同号) <br />
          电子邮箱：jingzhaoyin@mail.chinamso.com <br />
          联系地址：中国江苏自由贸易试验区（连云港片区）黄海大道58号  <br />
        </p>
        <!-- 底部二维码 -->
        <div class="bottom-box-right-text1">
          <img src="../../assets/imgs/公众号 拷贝.png" alt="">
          <p>微信公众号</p>
        </div>
        <!-- 底部版权 -->
        <p class="bottom-box-right-text2">Copyright © 2022-2024 江苏海宏智能科技有限公司 版权所有 &nbsp;<span style="cursor: pointer;" @click="jump_gxb">备案号：苏ICP备2021012348号-2</span></p>
      </div>
    </div>
    <!-- 回到顶部盒子 -->
    <div class="back-top">
        <el-button>
          <img src="../../assets/imgs/侧边栏/微信.png" alt="">
          <p>微信</p>
        </el-button>
        <el-button>
          <img src="../../assets/imgs/侧边栏/形状.png" alt="">
          <p>在线沟通</p>
        </el-button>
        <el-button>
          <img src="../../assets/imgs/侧边栏/电话.png" alt="">
          <p>联系电话</p>
        </el-button>
        <el-button @click="toTop">
          <img src="../../assets/imgs/侧边栏/dingbu.png" alt="">
          <p>返回顶部</p>
        </el-button>
    </div>
  </div>
</template>

<script>
export default {
  // 智能移动机器人小车系列
  name: 'Trolley',
  data () {
    return {
      search: '',
      urls: [
        { id: 1, text: '智能移动机器人', url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/AMR-036-2.jpg') },
        { id: 2, text: '智能移动机器人', url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/bdcd7977c52deea761efa41e07ab33e2d1964a36.jpg') },
        { id: 3, text: '智能移动机器人', url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/微信图片_20220722084154.jpg') },
        { id: 4, text: '智能移动机器人', url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/微信图片_202207220841541.jpg') },
        { id: 5, text: '智能移动机器人', url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/微信图片_202207220841542.jpg') }
        // { id: 6, url: require('../../assets/imgs/案例分享/1-框架页/1-移动机器人配图/1-小车配图/图片1.png') }
      ]
    }
  },
  created () {
    // 打开组件回到顶部
    this.toTop()
  },
  methods: {
    searchbtn () {
      console.log(this.search)
    },
    jump_gxb() {
      location.href = 'https://beian.miit.gov.cn/'
    },
    toTop () {
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.top-box{
  position: relative;
  width: 100%;
  height: 22.5rem;
  background-image: url('../../assets/imgs/案例分享/15.png');
  background-size: cover;
  background-repeat: no-repeat;
}

.top-p1{
  position: absolute;
  top: 7.25rem;
  left: 52.75rem;
  font-size: 3.75rem;
  font-weight: 700;
  color: #fffefe;
}

.top-p2{
  position: absolute;
  top: 12.8125rem;
  left: 48.625rem;
  font-size: 3.125rem;
  font-weight: 700;
  color: #fffefe;
}

.location-top{
  width: 100%;
  height: 100%;
  display: flex;
  padding-top: 3.625rem;
  padding-left: 8.125rem;
  line-height: 1.5625rem;
  font-size: 1.625rem;
}

/deep/ .location-top .el-breadcrumb__inner, /deep/ .el-icon-arrow-right:before,/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  font-size: 1.625rem;
  color: #000;
}

/deep/.location-top .el-breadcrumb__inner.is-link{
  font-weight: 400 !important;
}

/deep/.location-top .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #000;
}

.title{
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  margin-top: 3.625rem;
  width: 100%;
  height: 4rem;
  font-size: 2.25rem;
  color: #000;
}

.title-box{
  position: absolute;
  bottom: 0;
  width: 10.25rem;
  height: .3125rem;
  background-color: #004ea1;
}

.text{
  margin-left: 19.1875rem;
  margin-top: 4.375rem;
  width: 80.9375rem;
  height: 100%;
  line-height: 4.375rem;
  font-size: 1.75rem;
  color: #5e5e5e;
  background-color: pink;
}

.title1{
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 6.5rem;
  width: 100%;
  height: 4.0625rem;
  font-size: 2.25rem;
  color: #000;
}

.title1-box{
  position: absolute;
  bottom: 0;
  width: 3.0625rem;
  height: .3125rem;
  background-color: #004ea1;
}

.bottom-img{
  position: relative;
  margin: 5.5rem 0 16.875rem 18.8125rem;
  width: 82.4375rem;
  height: 100%;
  background-color: #fff;
}

.bottom-img1{
  position: relative;
  margin-top: 4.875rem;
  display: inline-block;
  width: 40rem;
  height: 31.3125rem;
  background-color: #fff;
}

.bottom-img1:nth-child(even){
  margin-left: 2.4375rem;
}

.bottom-img1:nth-child(-n+2){
  margin-top: 0;
}

.bottom-img1 img{
  width: 40rem;
  height: 26.25rem;
}

.bottom-img1 p{
  position: absolute;
  left: 13.1875rem;
  bottom: 0;
  margin-top: 3.375rem;
  font-size: 1.75rem;
  color: #000;
}

.bottom-img2{
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 40rem;
  height: 26.25rem;
}

.bottom-img2 img{
  position: absolute;
  top: -4.0625rem;
  width: 45.375rem;
  height: 21.875rem;
}

.bottom-img2 p{
  position: absolute;
  bottom: 0;
  font-size: 1.75rem;
  color: #000;
}

</style>
